var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0664 11.5H10.9375L10.6914 10.2969C10.6367 9.99609 10.3633 9.75 10.0625 9.75H7.32812C7.13672 9.75 7 9.91406 7 10.0781V10.7344C7 10.9258 7.13672 11.0625 7.32812 11.0625H9.51562L11.4023 20.7969C11.1016 21.125 10.9375 21.5352 10.9375 22C10.9375 22.9844 11.7031 23.75 12.6875 23.75C13.6445 23.75 14.4375 22.9844 14.4375 22C14.4375 21.6992 14.3281 21.3984 14.1914 21.125H18.1562C18.0195 21.3984 17.9375 21.6992 17.9375 22C17.9375 22.9844 18.7031 23.75 19.6875 23.75C20.6445 23.75 21.4375 22.9844 21.4375 22C21.4375 21.5078 21.2188 21.0703 20.8906 20.7422L20.918 20.6328C21 20.2227 20.6992 19.8125 20.2617 19.8125H12.5508L12.3047 18.5H20.8359C21.1641 18.5 21.4102 18.3086 21.4922 18.0078L22.7227 12.3203C22.8047 11.9102 22.5039 11.5 22.0664 11.5ZM12.6875 22.6562C12.3047 22.6562 12.0312 22.3828 12.0312 22C12.0312 21.6445 12.3047 21.3438 12.6875 21.3438C13.043 21.3438 13.3438 21.6445 13.3438 22C13.3438 22.3828 13.043 22.6562 12.6875 22.6562ZM19.6875 22.6562C19.3047 22.6562 19.0312 22.3828 19.0312 22C19.0312 21.6445 19.3047 21.3438 19.6875 21.3438C20.043 21.3438 20.3438 21.6445 20.3438 22C20.3438 22.3828 20.043 22.6562 19.6875 22.6562ZM20.3164 17.1875H12.0312L11.1836 12.8125H21.2734L20.3164 17.1875Z",
    fill: "#36424E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3cbf83b37d9faee8b6da9cfaf59ea73a.svg";
export { ForwardRef as ReactComponent };